import React from "react";
import SearchTerm2Component from "./searchTerm2.component";
import { useSelector } from "react-redux";

export default function SearchTerm2Container({ id, isTemplateEditor }) {
  const { isVisible } = useSelector((state) =>
    isTemplateEditor
      ? state.products.template.workspaceSetting.setting.components[id]
      : state.productPage.components[id]
  );
  const lang = useSelector((state) => state.constant.languages);
  const language = useSelector((state) => state.profile.language);
  const uiSetting = useSelector((state) => state.setting.uiSetting);

  return (
    isVisible && (
      <SearchTerm2Component
        lang={lang}
        language={language}
        uiSetting={uiSetting}
      />
    )
  );
}
